'use client';

import { useEffect } from 'react';

import { clearGiftPreview } from '@/app/_components/GiftCard/giftPreview';

//* 상세 본문이 마운트되면 프리뷰를 걷는다 — 페이지와 layout이 형제라 스토어로 신호를 보낸다
export const GiftEntryPreviewDismiss = () => {
  useEffect(() => {
    clearGiftPreview();
  }, []);

  return null;
};
